import React from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress
} from '@mui/material';
import { Add } from '@mui/icons-material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';


const NuevoAvance = ({
  nuevoAvance,
  handleAvanceChange,
  handleFileChange,
  handleSubmitAvance,
  submittingAvance,
  disabled,
  handleRemoveArchivo,
  handleClearAvance 
}) => {
  return (
    <Paper elevation={2} style={{ padding: '1.3rem', backgroundColor: '#f0f0f0', marginBottom: '1rem' }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        Crear Avance
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        label="Descripción del avance"
        name="descripcion"
        value={nuevoAvance.descripcion}
        onChange={handleAvanceChange}
        sx={{ mb: 2 ,
        backgroundColor: 'white'
        }}
        disabled={disabled}
      />

         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' , justifyContent: 'flex-end'  }}>
         <Button
          variant="contained"  
          component="label"
          color="success"
          startIcon={<AttachFileIcon />}
          sx={{
            minWidth: 115,
            height: 38,  
            fontWeight: 'bold',
          }}
        >
          Adjuntar
          <input
            type="file"
            hidden
            multiple
            onChange={handleFileChange}
          />
        </Button>

          <Button
            variant="outlined"
            onClick={handleClearAvance}
            startIcon={<DeleteOutlineIcon />}
            sx={{
              minWidth: 115,
              height: 38,
              color: '#FF0000',          
              borderColor: '#FF0000',    
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: 'rgba(255, 0, 0, 0.08)', 
                borderColor: '#B22222',  
                color: '#B22222',        
              },
            }}
          >
            Limpiar
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmitAvance}
            disabled={submittingAvance || !nuevoAvance.descripcion}
            startIcon={submittingAvance ? <CircularProgress size={20} /> : <Add />}
            sx={{
              minWidth: 115,
              height: 38,
              backgroundColor: '#19438C',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#19438C',
              },
            }}
          >
            {submittingAvance ? 'Guardando...' : 'Guardar '}
          </Button>

          
        </Box>

         {nuevoAvance.archivos?.length > 0 && (
          <Box sx={{ mt: 1 }}>
            {nuevoAvance.archivos.map((file, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  {file.name}
                </Typography>
                <Button
                  size="small"
                  color="error"
                  onClick={() => handleRemoveArchivo(index)}
                >
                  <DeleteIcon />    
                </Button>
              </Box>
            ))}
          </Box>
        )}
    </Paper>
  );
};

export default NuevoAvance;
